import { useMemo } from 'react';
import { InitiatePayload } from 'flows/core/types/cards';
import { isTaskCompletedOrValidating } from 'flows/core/utils/card-makers/utils';

export interface ProgressTotals {
  totalTasks: number;
  completedTasks: number;
  pct: number;
}

export const useProgressTotals = (
  priorityCards: InitiatePayload[] | undefined,
  completedCards: InitiatePayload[] | undefined
): ProgressTotals => {
  return useMemo(() => {
    const completedRequiredTasks = (completedCards || []).filter(
      (card: InitiatePayload) =>
        isTaskCompletedOrValidating(card.data) &&
        (card.data?.required || card.data?.priority)
    );

    const totalTasks =
      (priorityCards?.length || 0) + completedRequiredTasks.length;
    const completedTasks =
      (priorityCards?.filter((card: InitiatePayload) =>
        isTaskCompletedOrValidating(card.data)
      ).length || 0) + completedRequiredTasks.length;

    const pct =
      totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

    return { totalTasks, completedTasks, pct };
  }, [priorityCards, completedCards]);
};
